import makeService from './api';

export default makeService('machine_models');
